module.exports = __webpack_public_path__ + "images/5f6a0dbcd72892447b8d897283b0bdcc.png";